import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { MagnifyingGlass } from "@phosphor-icons/react";
import { getMyProjectReviews } from "./api";
import ProjectReviewModal from "./ProjectReviewModal";

/**
 * Inceleme aksiyonu — yalnizca review_enabled projelerde (bitirme) render edilir.
 * Render karari cagirana ait (TaskItem, reviewEnabled + kilit acik). Bitirme
 * projeleri testsiz oldugu icin skor esigi aranmaz; ogrenci repo linkiyle
 * dogrudan inceleme talebi acar.
 */
export default function ReviewAction({ projectId }: { projectId: number; score?: number | null }) {
  const [open, setOpen] = useState(false);
  const { data: reviews } = useQuery({
    queryKey: ["myProjectReviews"],
    queryFn: getMyProjectReviews,
    staleTime: 60_000,
  });
  const latest = reviews?.find((r) => r.project_id === projectId) ?? null;

  const label =
    latest?.status === "pending" ? "İncelemede ⏳"
    : latest?.status === "answered" ? "İnceleme hazır ✦"
    : "İncelet 🔍";
  const cls =
    latest?.status === "answered"
      ? "text-myGreen bg-myGreen/10 hover:bg-myGreen/20"
      : "text-white/40 bg-white/[0.04] hover:bg-white/10 hover:text-white/70";

  return (
    <>
      <button
        onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpen(true); }}
        className={`flex items-center gap-1 text-[11px] px-2 py-1 rounded-lg transition-colors cursor-pointer whitespace-nowrap ${cls}`}
      >
        <MagnifyingGlass size={12} />
        {label}
      </button>
      {open && (
        <ProjectReviewModal projectId={projectId} latest={latest} onClose={() => setOpen(false)} />
      )}
    </>
  );
}
